module.exports = __webpack_public_path__ + "media/src/neighbourhood_map/images/ligne15-ffc68b02af3f61fa4bfce140eab76795.png";